module.exports = __webpack_public_path__ + "img/bnb.6dae5e8d.svg";